import { Flex, Text, VStack } from "@chakra-ui/react";
import { AssetId } from "../../config/assets";
import { DeFiOpportunities } from "../../rest/kairos/types";
import { CompoundOpportunityCard } from "./CompoundOpportunityCard";
import {
  COMPOUND_STRATEGIES_BY_ASSET,
  findDeFiOpportunityById,
  resolveCompoundPoolMetrics,
} from "./compoundOpportunities";

interface CompoundOpportunitiesSectionProps {
  assetId: AssetId;
  opportunities: DeFiOpportunities[];
  isLoading: boolean;
}

export const CompoundOpportunitiesSection = ({
  assetId,
  opportunities,
  isLoading,
}: CompoundOpportunitiesSectionProps) => {
  const strategies = COMPOUND_STRATEGIES_BY_ASSET[assetId];
  if (!strategies?.length) return null;

  return (
    <VStack spacing={4} align="stretch">
      <Text fontSize="lg" fontWeight="semibold" color="white">
        DeFi Strategies
      </Text>
      <Flex gap={4} direction={{ base: "column", sm: "row" }} align="stretch" width="100%">
        {strategies.map((config) => {
          const opportunity = findDeFiOpportunityById(opportunities, config.defiId);
          const metrics = resolveCompoundPoolMetrics(opportunity, isLoading);

          return (
            <CompoundOpportunityCard
              key={config.defiId}
              href={opportunity?.protocolUrl ?? config.fallbackDestination}
              destinationTracking={config.destinationTracking}
              tokenIcons={config.tokenIcons}
              badge={config.badge}
              title={config.title}
              protocolName={config.protocol}
              protocolLogo={opportunity?.protocolLogo}
              strategyType={config.strategyType}
              tvl={metrics.tvl}
              apy={metrics.apy}
              tvlLoading={metrics.tvlLoading}
              apyLoading={metrics.apyLoading}
            />
          );
        })}
      </Flex>
    </VStack>
  );
};
